

































































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class KedatanganPasienIgd extends Vue {
  timePickerProps = { format: "24hr", scrollable: true };
  datePickerProps = { locale: "id" };
  loading = false;

  arivedAt = new Date();
  triage = null;
  arival = null;
  transportasi = null;
  transportasiDescription = null;
  kasus = null;
  arivalDescription = null;
  kasusDescription = null;

  arivalOptions = [
    { id: 1, name: "Datang Sendiri" },
    { id: 2, name: "Diantar" },
    { id: 3, name: "Rujukan" },
    { id: 99, name: "Lainnya" }
  ];
  transportasiOptions = [
    { id: 1, name: "Ambulance" },
    { id: 0, name: "Non Ambulance" }
  ];
  kasusOptions = [
    { id: 0, name: "Non-Trauma" },
    { id: 1, name: "Trauma" },
    { id: 2, name: "Obsgyn" },
    { id: 3, name: "Anak" },
    { id: 99, name: "Lainnya" }
  ];
  triageOptions = [
    { id: 1, name: "Kategori 1", color: "#B71C1C" },
    { id: 2, name: "Kategori 2", color: "#EF5350" },
    { id: 3, name: "Kategori 3", color: "yellow" },
    { id: 4, name: "Kategori 4", color: "#1B5E20" },
    { id: 5, name: "Kategori 5", color: "#66BB6A" },
    { id: 0, name: "Meninggal", color: "black" }
  ];

  get arivalDescriptionLabel() {
    if (this.arival.id == 2) {
      return "Diantar oleh";
    }

    if (this.arival.id == 3) {
      return "Rujukan dari";
    }

    if (this.arival.id == 99) {
      return "Sebutkan kedatangan lainnya";
    }

    return "Sebutkan";
  }

  get triageColor() {
    const val = this.triageOptions.find(item => {
      return this.triage && this.triage.id == item.id;
    });

    console.log(val);

    return val ? val.color : null;
  }
}
